import { create } from "zustand";

export const useExlyConnectStore = create((set) => ({
  isValidZoomUser: false, // Whether the user has valid zoom license
  webinarMinutes: 0, // Available exly zoom webinar minutes
  setIsValidZoomUser: (value) => {
    set({ isValidZoomUser: value });
  },
  setWebinarMinutes: (value) => {
    set({ webinarMinutes: value });
  },
}));
